const imagenes = {
	banner : require("./banner.webp"),
	banner2: require("./a.webp"),
	campo : require("./campo.webp"), 
	casa : require("./casa.webp"), 
	depto : require("./depto.webp"), 
	galpones : require("./galpones.webp"), 
	logo : require("./logo.ico"), 
	oficina : require("./oficina.webp"), 
	terrenos : require("./terrenos.webp"), 
	op1 : require("./a (1).webp"), 
	op2 : require("./a (2).webp"), 
	op3 : require("./a (3).webp"), 
	op4 : require("./a (4).webp"), 
	op5 : require("./a (5).webp"), 
	op6 : require("./a (6).webp"), 
	op7 : require("./a (7).webp"), 
	op8 : require("./a (8).webp"), 
	op9 : require("./a (9).webp"), 
	op10 : require("./a (10).webp")

	
	/* 	termas1: require("./img/Turismo/Termas/1A2F-Multimedios-4.webp"),
	 */
};
export default imagenes;
